export const colors = {
  red: '#FF0000',
  redOpacity: 'rgba(255,0,0, 0.9)',
  White: '#fff',
  black: '#000',
  blackOpacity: 'rgba(0, 0, 0, 0.7)',
  gray: '#c1c1c1',
  blue: '#01597C',
  blueOpacity: 'rgba(1, 89, 124, 0.3)',
  div: '#f1f1f1'
}

export const breakpoints = {
  desktop: '1025px',
  tablet: '1024px',
  mobile: '769px'
}
